// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5efe9c00","453":"89731ec4","455":"73fe303c"}[chunkId] + ".chunk.js";
};